import React, { useEffect, useState } from "react";
import { useLazyGetFilteredLogsQuery } from "../../features/logs/logsApiSlice";

const FilteredLogsFetcher = ({ filters, onDataFetched }) => {
  const [fetchLogs, { data, isLoading }] = useLazyGetFilteredLogsQuery();
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    // Mark as mounted on first render
    setHasMounted(true);
  }, []);

  useEffect(() => {
    // Always fetch all data for download - backend handles permission filtering
    // Fetch when filters change OR when component mounts
    if (hasMounted) {
      fetchLogs({ page: 1, limit: 99999, filters }, true); // true forces refetch
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters, hasMounted]);

  useEffect(() => {
    if (data && onDataFetched) {
      onDataFetched(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return null; // no UI rendered
};

export default FilteredLogsFetcher;

